import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "challenges",
  class: "flex flex-col mt-40 items-center"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "gradient-text font-bold text-3xl w-auto" }, " Desafios disponíveis ", -1)
const _hoisted_3 = { class: "w-full flex flex-col items-center max-w-6xl mt-10 mb-52" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "gradient-1 w-full max-w-4xl h-44 shadow-none -mb-40 opacity-70" }, [
  /*#__PURE__*/_createVNode("div", { class: "background-dotted-pattern w-full h-full" })
], -1)
const _hoisted_5 = { class: 
              `card-link flex flex-col items-center justify-between w-full h-60 bg-white rounded-md shadow-lg my-10 mx-5 md:mx-10 p-5 outline-none`
             }
const _hoisted_6 = { class: "\n                    font-extrabold text-xl text-gray-700 leading-5\n                  " }
const _hoisted_7 = {
  key: 0,
  class: "w-full flex"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Começar o desafio! ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_orange_button = _resolveComponent("orange-button")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Slide = _resolveComponent("Slide")
  const _component_pagination = _resolveComponent("pagination")
  const _component_Carousel = _resolveComponent("Carousel")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode("section", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Carousel, {
        modelValue: _ctx.currentSlide,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentSlide = $event)),
        class: "w-full",
        "items-to-show": _ctx.smallWindow ? 1.3 : 3
      }, {
        addons: _withCtx(() => [
          (_ctx.smallWindow)
            ? (_openBlock(), _createBlock(_component_pagination, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.challenges, (challenge) => {
            return (_openBlock(), _createBlock(_component_Slide, { key: challenge }, {
              default: _withCtx(() => [
                _createVNode("article", _hoisted_5, [
                  _createVNode("header", {
                    class: 
                `w-full pt-2 flex flex-col items-start text-left whitespace-pre-wrap ${
                  !challenge.active ? 'opacity-50' : 'opacity-80'
                }`
              
                  }, [
                    _createVNode("h2", _hoisted_6, _toDisplayString(challenge.title), 1),
                    _createVNode("span", {
                      class: "text-sm text-gray-600 leading-4 mt-3",
                      innerHTML: challenge.subtitle
                    }, null, 8, ["innerHTML"])
                  ], 2),
                  (challenge.active)
                    ? (_openBlock(), _createBlock("footer", _hoisted_7, [
                        _createVNode(_component_router_link, {
                          to: challenge.route,
                          class: "card-link w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_orange_button, { class: "mt-10 text-sm w-full" }, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "items-to-show"])
    ])
  ]))
}